import React from "react";
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import "./Navbar.css";

const Navbar: React.FC = () => {
   const { user, logout} = useAuth();
    const navigate = useNavigate();

      const handleLogout = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        logout();
        navigate('/login');
    };




  return (
    <div className="navbar-custom">
      <div className="topbar container-fluid">
        <div className="d-flex align-items-center gap-lg-2 gap-1">
          {/* Topbar Brand Logo */}
          <div className="logo-topbar">
            {/* Logo light */}
            {/* <a href="/" className="logo-light">
              <span className="logo-lg">
                <img src="assets/images/logo.png" alt="Sosia +" />
              </span>
              <span className="logo-sm">
                <img src="assets/images/logo-sm.png" alt="Sosia +" />
              </span>
            </a> */}

            {/* Logo Dark */}
            <a href="/" className="logo-dark">

              <span className="logo-lg">
                <img
                  src="assets/images/TAHMOLOGO.png"
                  alt="TAHMO"
                  width="108px"
                  height="auto"
                  style={{ paddingLeft: 15 }}
                />
              </span>

              {/* <span className="logo-sm">
                <img src="assets/images/logo.png" alt="Sosia +" />
              </span> */}
            </a>
          </div>

          {/* Sidebar Menu Toggle Button */}
          {/* <button className="button-toggle-menu">
            <i className="mdi mdi-menu"></i>
          </button> */}

          {/* Horizontal Menu Toggle Button */}
          <button
            className="navbar-toggle"
            data-bs-toggle="collapse"
            data-bs-target="#topnav-menu-content"
          >
            <div className="lines">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </button>

          {/* Topbar Search Form */}
          <div className="app-search dropdown d-none d-lg-block">
            <div
              className="dropdown-menu dropdown-menu-animated dropdown-lg"
              id="search-dropdown"
            >
              {/* item*/}
            </div>
          </div>
        </div>

        <ul className="topbar-menu d-flex align-items-center gap-3">
          <li className="dropdown">
            <a
              className="nav-link dropdown-toggle arrow-none nav-user px-2"
              data-bs-toggle="dropdown"
              href="#"
              role="button"
              aria-haspopup="false"
              aria-expanded="false"
            >
              <span className="account-user-avatar">
                {/* <img
                  src="assets/images/users/avatar-1.jpg"
                  alt="user-image"
                  width="32"
                  className="rounded-circle"
                /> */}
              </span>
              <span className="d-lg-flex flex-column gap-1 d-none">
                <h5 className="my-0">{user?.name}</h5>
                {/* <h6 className="my-0 fw-normal">
                  {currentUser && currentUser.userType}
                </h6> */}
              </span>
            </a>
            <div className="dropdown-menu dropdown-menu-end dropdown-menu-animated profile-dropdown">
              {/* item*/}
              <div className=" dropdown-header noti-title">
                <h6 className="text-overflow m-0">Welcome !</h6>
              </div>

              {/* item*/}

              {/* item*/}
              <a href="#" className="dropdown-item notify-item" onClick={handleLogout}>
                                <i className="mdi mdi-logout me-1"></i>
                                <span>Logout</span>
                            </a>

            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
